import { jsx, jsxs } from "react/jsx-runtime";
import { Link, Text } from "@nxt-costco-com/forge-components";
import { SpaceSm } from "@nxt-costco-com/forge-design-tokens";
import { Analytics } from "../../../Analytics/index.js";
import { INVALID_PROPS_ERROR, COMPONENT_NAME } from "../constants.js";
import { Variants } from "../types.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { CategoryTileSkeleton } from "./SkeletonView/index.js";
import { getCategoryTileStyles } from "./lib.js";
import { ImageComponent } from "./view.image.js";
const CategoryTileUI = (props) => {
  const {
    categoryData,
    variant = Variants.STACKED,
    isLoading,
    hasCategoryTitle = true,
    foreground = true,
    background = true,
    dataTestId,
    imageSx = {},
    linkSx = {},
    titleSx = {}
  } = props;
  const { hrefUrl, imageUrl, subTitle, title, target } = categoryData || {};
  if (!categoryData || !imageUrl || !hrefUrl || !foreground && !background) {
    console.error(INVALID_PROPS_ERROR);
    return null;
  }
  if (isLoading) {
    return /* @__PURE__ */ jsx(CategoryTileSkeleton, { imageSx, variant });
  }
  const altText = !hasCategoryTitle ? title : "";
  const categoryTileStyles = getCategoryTileStyles(
    props
  );
  const {
    containerStyles,
    linkStyles = {},
    titleStyles = {}
  } = categoryTileStyles;
  return /* @__PURE__ */ jsx(CostcoBox, { "data-testid": dataTestId, sx: containerStyles, children: /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: { adItem: { link: hrefUrl, title } },
      children: /* @__PURE__ */ jsxs(
        Link,
        {
          dataPrivate: categoryData == null ? void 0 : categoryData.disableThirdPartyTracking,
          href: hrefUrl,
          sx: { ...linkStyles, ...linkSx },
          underline: "hover",
          variant: "t5",
          target,
          children: [
            /* @__PURE__ */ jsx(
              ImageComponent,
              {
                altText,
                categoryTileStyles,
                ...props
              }
            ),
            /* @__PURE__ */ jsxs(
              CostcoBox,
              {
                sx: {
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginTop: SpaceSm
                },
                children: [
                  hasCategoryTitle && /* @__PURE__ */ jsx(
                    Text,
                    {
                      sx: {
                        ...titleStyles,
                        ...titleSx
                      },
                      bold: true,
                      variant: "t6",
                      children: title
                    }
                  ),
                  subTitle && /* @__PURE__ */ jsx(
                    Text,
                    {
                      sx: {
                        ...titleStyles,
                        ...titleSx
                      },
                      variant: "t6",
                      children: subTitle
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  ) });
};
CategoryTileUI.displayName = COMPONENT_NAME;
export {
  CategoryTileUI
};
